import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    owner: String,
    template: String,
    width: { type: String, default: "width-md" }
  }

  connect() {
    this._boundClickHandler = this._handleClick.bind(this)
    document.addEventListener("click", this._boundClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this._boundClickHandler)
  }

  _handleClick(event) {
    const link = event.target.closest("[data-sidenav-tab]")
    if (!link) return

    const owner = link.dataset.sidenavOwner
    if (owner) {
      if (!this.hasOwnerValue || owner !== this.ownerValue) return
    } else if (!this.element.contains(link)) {
      return
    }

    event.preventDefault()

    const tab = link.dataset.sidenavTab
    const templateId = link.dataset.sidenavTemplate || this.templateValue
    const template = document.getElementById(templateId)
    if (!template) return

    const frame = document.getElementById("sidenav_content")
    frame.innerHTML = ""
    frame.append(template.content.cloneNode(true))

    const sidenavRoot = document.getElementById("sidenav")
    const isCareerAssistantSidenav = !!frame.querySelector(".career-assistant-sidebar")
    sidenavRoot?.classList.toggle("career-assistant-sidenav", isCareerAssistantSidenav)

    turboStreamEventHandler.closeTippy()
    sidenav.cleanAndOpen(this.widthValue)
    if (link.dataset.sidenavAudit) sidenav.audit(link.dataset.sidenavAudit)
    reinitializeTippy()

    if (tab) {
      requestAnimationFrame(() => {
        const tabsEl = frame.querySelector("[data-controller*='tabs']")
        const ctrl = this.application.getControllerForElementAndIdentifier(tabsEl, "tabs")
        ctrl?.activateByKey(tab)
      })
    }
  }
}
